/**
 * Content Grid Styles
 * Carbon Design System compliant styling for educational content grid
 */
.contentGrid {
  padding: 1rem;
  min-height: 100vh;
}
.contentGrid .header {
  margin-bottom: 2rem;
}
.contentGrid .header h2 {
  color: var(--cds-text-primary);
  margin-bottom: 0.5rem;
}
.contentGrid .header p {
  color: var(--cds-text-secondary);
  margin-bottom: 1.5rem;
}
.contentGrid .skeletonTile {
  height: 300px;
  padding: 1rem;
}
.contentGrid .skeletonTile .cds--skeleton__text {
  margin-bottom: 0.5rem;
}
.contentGrid .emptyState {
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: 2px dashed var(--cds-border-subtle);
}
.contentGrid .emptyState h3 {
  color: var(--cds-text-primary);
  margin-bottom: 0.5rem;
}
.contentGrid .emptyState p {
  color: var(--cds-text-secondary);
  margin-bottom: 1rem;
}
@media (max-width: 672px) {
  .contentGrid {
    padding: 0.5rem;
  }
  .contentGrid .header {
    margin-bottom: 1rem;
  }
}
@media (min-width: 1312px) {
  .contentGrid {
    padding: 2rem;
  }
}
[data-carbon-theme=g100] .contentGrid .emptyState {
  border-color: var(--cds-border-subtle);
}

.tableView .cds--data-table {
  margin-top: 1rem;
}
.tableView .cds--data-table td {
  vertical-align: top;
  padding: 1rem 0.75rem;
}
.tableView .performanceCell {
  min-width: 120px;
}
.tableView .actionsCell {
  min-width: 140px;
}

.loadingGrid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1rem;
  margin-top: 2rem;
}

.loadMoreButton {
  margin-top: 1rem;
}

.loadingCard {
  height: 280px;
  padding: 1rem;
  background: var(--cds-layer);
  border-radius: 4px;
}

.filtersSection {
  background: var(--cds-layer);
  padding: 1rem;
  border-radius: 4px;
  margin-bottom: 1.5rem;
}
.filtersSection .filterRow {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  align-items: end;
}
@media (max-width: 672px) {
  .filtersSection .filterRow {
    flex-direction: column;
    align-items: stretch;
  }
  .filtersSection .filterRow .cds--dropdown,
  .filtersSection .filterRow .cds--search {
    width: 100%;
  }
}

.pagination {
  margin-top: 2rem;
  display: flex;
  justify-content: center;
}

.contentGrid {
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.contentGrid .cds--tile:focus {
  outline: 2px solid var(--cds-focus);
  outline-offset: 2px;
}
.contentGrid .cds--tag:focus {
  outline: 2px solid var(--cds-focus);
  outline-offset: 1px;
}

@media (prefers-contrast: high) {
  .contentGrid .emptyState {
    border-width: 3px;
    border-color: var(--cds-text-primary);
  }
  .contentGrid .cds--tile {
    border: 1px solid var(--cds-border-strong);
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */